import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, FormControl, InputLabel, Select, MenuItem, Typography, Box,
} from '@mui/material';

function ColumnMappingDialog({
  open, fileHeaders, columnMapping, onMappingChange, onConfirm, onCancel,
}) {
  const allMapped = fileHeaders.every((f) => columnMapping[f.name]);

  const handleClose = (event, reason) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
    onCancel();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Select Column to Hash</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          We couldn&apos;t automatically identify the column to hash. Please select the correct
          column for each file below.
        </Typography>

        {fileHeaders.map((file, index) => (
          <Box key={file.name} sx={{ mb: 2 }}>
            <Typography variant="body2" sx={{ mb: 1, fontWeight: 'bold' }}>
              {file.name}
            </Typography>
            <FormControl fullWidth size="small">
              <InputLabel id={`col-label-${index}`}>Column</InputLabel>
              <Select
                labelId={`col-label-${index}`}
                label="Column"
                value={columnMapping[file.name] || ''}
                onChange={(e) => onMappingChange(file.name, e.target.value)}
              >
                {file.headers.map((col) => (
                  <MenuItem key={col} value={col}>{col}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>
        <Button onClick={onConfirm} variant="contained" disabled={!allMapped}>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ColumnMappingDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  fileHeaders: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    headers: PropTypes.arrayOf(PropTypes.string).isRequired,
  })).isRequired,
  columnMapping: PropTypes.objectOf(PropTypes.string).isRequired,
  onMappingChange: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default ColumnMappingDialog;
